import React, { useCallback, useRef, useEffect } from 'react'
import { MainContentContainer } from './styles'
import { useWindowSize } from '../../../hooks/useWindowSize'
import StatsEventTable from '../../Shared/StatsEventTable'

const PIXELS_TO_SCROLL = 50;

export const MainContent = (props) => {
  const {
    isOpenRightMenu,
    tradeList,
    users,
    isLoadMore,
    paginationProps,
    getTradeList
  } = props
  
  const windowSize = useWindowSize()
  const containerRef = useRef()

    const handleScroll = useCallback(() => {
    if (isLoadMore) return;

    const innerHeightScrolltop =
    containerRef?.current.offsetHeight +
    containerRef?.current.scrollTop +
      PIXELS_TO_SCROLL;
      if (containerRef?.current.scrollHeight < innerHeightScrolltop && paginationProps.current_page <= paginationProps.total_pages) {
        getTradeList(paginationProps.current_page + 1, paginationProps.page_size)
      }
  }, [isLoadMore, paginationProps, getTradeList])

  useEffect(() => {
    containerRef?.current?.addEventListener("scroll", handleScroll);
    return () => {
      containerRef?.current?.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll])

  return (
    <MainContentContainer style={(windowSize.width < 800 && isOpenRightMenu) ? {display: 'none'} : {display: 'block'}} ref={containerRef}>
      <StatsEventTable tradeList={tradeList} users={users} isLoadMore={isLoadMore} />
    </MainContentContainer>
  )
}